import * as React from 'react';
import { Price } from '@grandvisionhq/common';
import { useIntl } from '@grandvisionhq/state';

const Prices = ({ price , discountedPrice  })=>{
    const { currency  } = useIntl();
    const hasDiscount = !!discountedPrice && discountedPrice !== price;
    return /*#__PURE__*/ React.createElement("div", {
        className: "product-block-prices"
    }, /*#__PURE__*/ React.createElement(Price, {
        value: discountedPrice !== null && discountedPrice !== void 0 ? discountedPrice : price,
        currency: currency,
        size: "small",
        type: hasDiscount ? 'discount' : 'default'
    }), hasDiscount && /*#__PURE__*/ React.createElement(Price, {
        value: price,
        currency: currency,
        size: "small",
        type: "strikethrough"
    }));
};
var Prices$1 = Prices;

export { Prices, Prices$1 as default };
//# sourceMappingURL=Prices.js.map
